export default "__VITE_ASSET__NIxNaSf3__"